var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"article"}},[_c('NavTop',{attrs:{"title":_vm.article.title}}),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.article.content)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }